export const ADD_PAYMENT_METHOD_PATH = "/profile/add-credit-card";
export const PAYMENT_SETTINGS_PATH = "/profile/payment";
export const INVOICES_PATH = "/profile/invoices";
